export const DBEntityDependencyErrorType = 'entity-has-dependencies';
//# sourceMappingURL=types.js.map